import * as constants from '../constants';

/**
 * Reveal one or more masked KYC values.
 *
 * Every call is gated server-side (permission, document status, ownership, rate limit) and
 * written to kyc_reveal_audit before any value is returned — including denials. The response
 * carries a per-item `outcome`, so a 200 does not mean the value was revealed; check
 * `results[].outcome === 'ALLOWED'` and `results[].rawReturned`.
 *
 * A successful reveal also opens a 120s grant, during which the normal get-KYC call returns the
 * raw value for that document. That is why callers refetch rather than caching what they get here.
 */
export const revealStaffKyc = (staffId, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${staffId}/kyc/reveal`,
        method: 'POST',
        data,
        success: (response) => ({
            type: constants.DO_NOTHING,
            payload: response?.response,
        }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const revealLeadKyc = (leadId, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/lead/${leadId}/kyc/reveal`,
        method: 'POST',
        data,
        success: (response) => ({
            type: constants.DO_NOTHING,
            payload: response?.response,
        }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});
